import { render, staticRenderFns } from "./infoSenhas.vue?vue&type=template&id=b4c146ee&scoped=true"
import script from "./infoSenhas.vue?vue&type=script&lang=js"
export * from "./infoSenhas.vue?vue&type=script&lang=js"
import style0 from "./infoSenhas.vue?vue&type=style&index=0&id=b4c146ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4c146ee",
  null
  
)

export default component.exports